import { ProviderConfig, ProviderTypes } from 'types';
import { DefaultTheme } from 'config/themes';

export const FidiumFiber: ProviderConfig = {
  providerType: ProviderTypes.LEC,
  providerCode: 'fidium_fiber',
  dcCode: 'fidium_fiber',
  name: 'FidiumFiber',
  displayName: 'Fidium Fiber',
  reskinTheme: DefaultTheme,
  reskinTitle: 'Fidium Fiber Internet',
  showPricingDisclaimer: true,
  disclaimerDisplaySettings: {
    showContractDisclaimer: true,
    showOfferDisclaimer: true,
    showPromotionsDisclaimer: true,
  },
  broadbandDisplayType: 'linkout_url',
};
